"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.33,5.32l-7.24-2.2a.28.28,0,0,0-.18,0L4.67,5.32a.32.32,0,0,0-.23.3V7.2a.32.32,0,0,0,.32.31H5.7v9.76a.32.32,0,1,0,.63,0V7.51H17.67v9.76a.32.32,0,1,0,.63,0V7.51h.94a.32.32,0,0,0,.32-.31V5.62A.32.32,0,0,0,19.33,5.32Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.2,8.14H12.63V9.72a.31.31,0,0,1-.32.31h-.62a.31.31,0,0,1-.32-.31V8.14H9.8a.32.32,0,0,0-.32.32v3.78a.31.31,0,0,0,.32.31h4.4a.31.31,0,0,0,.32-.31V8.46A.32.32,0,0,0,14.2,8.14Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,13.18H10.11v1.57a.31.31,0,0,1-.31.32H9.17a.32.32,0,0,1-.32-.32V13.18H7.28a.31.31,0,0,0-.32.31v3.78a.32.32,0,0,0,.32.32h4.41a.31.31,0,0,0,.31-.32V13.49A.31.31,0,0,0,11.69,13.18Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.72,13.18h-.94v1.57a.32.32,0,0,1-.32.32H14.2a.31.31,0,0,1-.31-.32V13.18h-1a.31.31,0,0,0-.31.31v3.78a.31.31,0,0,0,.31.32h3.78a.32.32,0,0,0,.32-.32V13.49A.31.31,0,0,0,16.72,13.18Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;